<template>
    <BaseDialog
        :showDialog="showSearchDialog"
        maxDialogWidth="800"
        maxCardHeight="700"
        :scrollable="true"
        :headline="dialogTitle"
        :close="closeDialog"
        :alvqa="alvqaContext + '-' + alvqa"
    >    
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col cols="11">
                        <SearchFilter 
                            :context="searchcontext" 
                            @keydown.enter="searchForListItems"
                            :alvqa="alvqaContext + '-' + alvqa + '-textfield-search'"
                        />
                    </v-col>
                    <v-col align-self="end" class="text-right">
                        <BaseIcon 
                            @click="searchForListItems" 
                            icon="fa-search" 
                            tooltipText="lang_GENERIC_CAPTION_SEARCH"
                            :alvqa="alvqaContext + '-' + alvqa + '-button-search'"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="showSearchResult" class="pb-3">
                    <v-col 
                        v-if="items.length !== 0"
                        class="pl-7"
                    >
                        <!--  CHECKBOX TO SELECT ALL ITEMS -->
                        <v-checkbox
                            v-if="!withoutCheckboxesList"
                            :alvqa="alvqaContext + '-' + alvqa + '-checkbox-all-select'"
                            v-model="allSelected"
                            @click.stop="selectAll"
                            hide-details
                            color="generalCheckbox"
                            :disabled="disabledAllSelect"
                        >
                            <template v-slot:label>
                                <BaseHeaderStats 
                                    :context="searchcontext" 
                                    typeStats="DIALOG"
                                    :alvqa="alvqaContext + '-' + alvqa"
                                    useContextForTotal="SearchDialog"
                                />
                            </template>
                        </v-checkbox>
                        <BaseHeaderStats 
                            v-else
                            :context="searchcontext" 
                            typeStats="DIALOG"
                            :alvqa="alvqaContext + '-' + alvqa"
                            useContextForTotal="SearchDialog"
                        />
                    </v-col>
                    <v-col 
                        v-else
                        :alvqa="alvqaContext + '-' + alvqa + '-text-none-found'"
                    >
                        0 {{ $t('lang_GENERAL_CAPTION_FOUND') }}
                    </v-col>
                </v-row>  
                <v-divider v-if="items.length > 0"></v-divider>    
                <v-list two-line>
                    <v-list-item-group
                        v-model="selected"
                        :multiple="withoutCheckboxesList ? false : true"
                        @change="checkSelectAll()"
                    >
                        <v-list-item
                            v-for="(item, i) in items"
                            :key="item.alvId"
                            :value="i"
                            @click="selectItem(item.alvId, i)"
                            :disabled="item.alvInternalDisable"
                            :alvqa="alvqaContext + '-' + alvqa + '-result-list-row-' + item.alvId"
                        >
                            <template v-slot:default="{ active }">
                                <v-list-item-action v-if="!withoutCheckboxesList" class="mr-2">
                                    <!--  CHECKBOX TO SELECT A SPECIFIC ITEM -->
                                    <v-checkbox
                                        :input-value="active"
                                        color="generalCheckbox"
                                        hide-details
                                        :disabled="item.alvInternalDisable"
                                        :alvqa="alvqaContext + '-' + alvqa + '-result-list-row-' + item.alvId + '-checkbox'"
                                    ></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title :alvqa="alvqaContext + '-' + alvqa + '-result-list-row-' + item.alvId + '-title'">
                                        <slot name="itemTitle" :item="item"></slot>
                                    </v-list-item-title>
                                    <v-list-item-subtitle :alvqa="alvqaContext + '-' + alvqa + '-result-list-row-' + item.alvId + '-subtitle'">
                                        <slot name="itemSubtitle" :item="item"></slot>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>

                <slot name="additionalContent"></slot>
            </v-container>
        </template>
        
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-spacer />
                    <v-col class="text-right">
                        <slot name="additionalButtons"></slot>
                        <BaseButton 
                            :disabled="!selectedItemIds.length" 
                            @click="add()"
                            :label="addButtonLabel"
                            :alvqa="alvqaContext + '-' + alvqa +  '-button-add'"
                        />
                    </v-col>
                </v-row>
            </v-container>        
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '../_base/BaseDialog'

import SearchFilter from '../_filters/SearchFilter'
import BaseIcon from '../_buttons/BaseIcon'
import BaseButton from '../_buttons/BaseButton'
import BaseHeaderStats from '../_base/BaseHeaderStats'

export default {
    name: "SearchDialog",
    components: {
        BaseDialog,
        SearchFilter,
        BaseIcon,
        BaseButton,
        BaseHeaderStats
    },
    props: { // Examples are from Publishing Contract Edit Form: Works Panel
        context: { // e.g. PublishingContract
            type: String, 
            default: '' 
        }, 
        alvqaContext: {
            type: String,
            default: ''
        },
        subcontext: { // e.g. Works
            type: String,
            default: ''
        }, 
        searchcontext: { // e.g. WorksForContract
            type: String,
            default: ''
        },
        addcontext: { // e.g. WorksToContract
            type: String,
            default: ''
        },
        uniqueIdRequired: {
            type: Boolean,
            default: false  
        },
        withoutCheckboxesList: {
            type: Boolean,
            default: false
        },
        addButtonLabel: String, // Needs to be lang const
        dialogTitle: String, // Needs to be lang const
    },
    data() {
        return {
            showSearchResult: false,   
            items: [],
            selected: this.withoutCheckboxesList ? null : [], // selected Checkboxes
            allSelected: false,
            disabledAllSelect: false,
            alvqa: 'dialog-search-dialog'
        }
    },
    computed: {
        showSearchDialog: {
            get() { return this.$store.getters.getShowSearchDialog },
            set(show) { this.$store.commit('setShowSearchDialog', show) }
        },
        selectedItemIds: { // selected items for add function
            get() { return this.$store.getters['getSelected' + this.searchcontext] },
            set(selected) { this.$store.commit('setSelected' + this.searchcontext, selected) }
        }
    },
    methods: {
        async searchForListItems() {
            this.$store.commit('setIsLoading', true)
            if(this.$store.getters['get' + this.searchcontext + 'Search']) {
                this.selectedItemIds = []
                this.selected = []
                this.allSelected = false

                this.showSearchResult = true
                this.items = await this.$store.dispatch('search' + this.searchcontext)
            }

            if(!this.$store.getters['get' + this.searchcontext + 'Search']) this.items = []

            // disable 'selectAll' checkbox if all rows are already added
            let selectable = this.items.reduce((num, item) => num + Number(!item.alvInternalDisable), 0)
            this.disabledAllSelect = selectable == 0

            this.$store.commit('setTotalListedSearchDialog', selectable)
            this.$store.commit('setTotalRecordsSearchDialog', this.items.length)
            this.$store.commit('setIsLoading', false)
        },
        async add() {     
            let selectedItems = []
            for(let i = 0; i < this.selected.length; i++) {
                selectedItems.push(this.items[this.selected[i]]) // to add the full items in frontend data table
            }
            await this.$store.dispatch('add' + this.addcontext, selectedItems) 
            this.searchForListItems()
        },        
        selectAll() {
            if(this.allSelected == true) {
                this.selected = []
                this.selectedItemIds = []
                for(let i = 0; i < this.items.length; i++) {
                    if( this.items[i].alvInternalDisable != true ){
                        this.selected.push(i)
                        this.selectedItemIds.push(this.items[i].alvId)
                    }
                }
            } else {
                this.selected = []
                this.selectedItemIds = []
                this.allSelected = false
            }
        },   
        checkSelectAll(){
            if(!this.withoutCheckboxesList) {
                let selectable = this.items.reduce((num, item) => num + Number(!item.alvInternalDisable), 0)

                if(this.selected.length === this.items.length || (selectable > 0 && selectable === this.selected.length)) 
                    this.allSelected = true
                else 
                    this.allSelected = false
            }
        },
        selectItem(alvId, rowId) { 
            if(!this.withoutCheckboxesList) {
                let indexOfItem = this.selected.indexOf(rowId) 
                if(indexOfItem >= 0) {
                    this.selectedItemIds.splice(this.items[rowId].alvId, 1)
                }
                else {
                    this.selectedItemIds.push(this.items[rowId].alvId)
                }
            } else {
                if(this.selectedItemIds.length === 0) {
                    this.selectedItemIds.push(this.items[rowId])
                    this.selectedItemIds[0]["rowId"] = rowId
                } else {
                    if(this.selectedItemIds[0]["rowId"] === rowId) {
                        this.selectedItemIds =  []
                    } else {
                        this.selectedItemIds =  []
                        this.selectedItemIds.push(this.items[rowId])
                        this.selectedItemIds[0]["rowId"] = rowId
                    }
                }
            }
        },         
        closeDialog() {
            this.showSearchDialog = false
            this.selectedItemIds = []
            this.selected = []
            this.items = []
            this.allSelected = false
            this.showSearchResult = false
            this.$store.commit('set' + this.searchcontext + 'Search', '')
            this.disabledAllSelect = false
            this.$store.commit('setTotalListedSearchDialog', 0)
            this.$store.commit('setTotalRecordsSearchDialog', 0)
        }
    }
}
</script>